import { render, staticRenderFns } from "./ResearchOutputInterests.vue?vue&type=template&id=d2668c60&scoped=true&"
import script from "./ResearchOutputInterests.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputInterests.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputInterests.vue?vue&type=style&index=0&id=d2668c60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2668c60",
  null
  
)

export default component.exports